export const frenchCountryCodes = ['fr', 're', 'gf', 'mq', 'gp', 'yt'];